import React, { useEffect } from "react";
import style from "./ButtonBar.module.css";
import { useArticle } from "../../../../Contexts/ArticleContext";
import { useCurrentPage } from "../../../../Contexts/CurrentPageContext";
import { usePages } from "../../../../Contexts/PagesContext";
import { useActiveArticle } from "../../../../Contexts/ActiveArticleContext";
import classNames from "classnames";

const ButtonBar = () => {
  const [articles, setArticles] = useArticle();
  const [currentPage, setCurrentPage] = useCurrentPage();
  const [pages, setPages] = usePages();
  const [activeArticle, setActiveArticle] = useActiveArticle();
  let temp = [];

  const setupPagination = () => {
    let num_of_pages = Math.ceil(articles.length / 6);
    for (let i = 1; i <= num_of_pages; i++) {
      temp.push(i);
    }
    setPages(temp);
  };

  useEffect(() => {
    setupPagination();
  }, [articles]);

  return (
    <div className={style.buttonBar + " " + style.buttonBar2}>
      {pages.map((i) => {
        return (
          <button
            key={i}
            onClick={() => {
              setActiveArticle(-1);
              setCurrentPage(i);
            }}
            className={classNames(
              style.buttons,
              i === currentPage ? style.active : null
            )}
          >
            {i}
          </button>
        );
      })}
    </div>
  );
};

export default ButtonBar;
